import { render, staticRenderFns } from "./mistakeRedo.vue?vue&type=template&id=303c40b5&scoped=true&"
import script from "./mistakeRedo.vue?vue&type=script&lang=js&"
export * from "./mistakeRedo.vue?vue&type=script&lang=js&"
import style0 from "./mistakeRedo.vue?vue&type=style&index=0&id=303c40b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303c40b5",
  null
  
)

export default component.exports